import { Skeleton } from '@mui/material';

import Typography from '../../../../../../components/Typography';

const PollIdentifierSkeleton = () => {
  return (
    <Typography variant="textXsBold" color="grey.500" lineHeight="unset">
      <Skeleton variant="text" width={200} />
    </Typography>
  );
};

export default PollIdentifierSkeleton;
